export interface DataAccessObject {
  accessKeys: string[];
}

export interface DataAccessType {
  rolePrefix: string;
  accessKeys: string[];
}

export const accessGlobal = (data: DataAccessObject): DataAccessType => ({
  rolePrefix: 'global.',
  accessKeys: data?.accessKeys,
});

export const anyGlobal: DataAccessType = accessGlobal({ accessKeys: ['any'] });

export const accessReport = (data: DataAccessObject): DataAccessType => ({
  rolePrefix: 'report.',
  accessKeys: data?.accessKeys,
});

export const anyReport: DataAccessType = accessReport({ accessKeys: ['any'] });

export const accessAsset = (data: DataAccessObject): DataAccessType => ({
  rolePrefix: 'asset.',
  accessKeys: data?.accessKeys,
});

export const anyAsset: DataAccessType = accessAsset({ accessKeys: ['any'] });

export const accessProject = (data: DataAccessObject): DataAccessType => ({
  rolePrefix: 'project.',
  accessKeys: data?.accessKeys,
});

export const anyProject: DataAccessType = accessProject({ accessKeys: ['any'] });

export const accessTask = (data: DataAccessObject): DataAccessType => ({
  rolePrefix: 'task.',
  accessKeys: data?.accessKeys,
});

export const anyTask: DataAccessType = accessTask({ accessKeys: ['any'] });

export const accessForecast = (data: DataAccessObject): DataAccessType => ({
  rolePrefix: 'forecast.',
  accessKeys: data?.accessKeys,
});

export const anyForecast: DataAccessType = accessForecast({ accessKeys: ['any'] });

/* user profile access */
export const accessUserProfile = (data: DataAccessObject): DataAccessType => ({
  rolePrefix: 'user.',
  accessKeys: data?.accessKeys,
});

export const anyUserProfile: DataAccessType = accessUserProfile({ accessKeys: ['any'] });
